import { defineStore } from 'pinia'
import { ref, h, toRef, shallowRef } from 'vue'
import type { Component } from 'vue'

export type DialogSize = 'small' | 'medium' | 'large' | 'xl' | 'full'

export interface DialogOptions {
    size?: DialogSize
    raw?: boolean
}

const DEFAULT_OPTIONS: Required<DialogOptions> = { size: 'medium', raw: true }

export const useDialog = defineStore('dialogComponent', () => {
    const isOpen = ref(false)
    const content = shallowRef<Component>(h('div'))
    const bindProperties = ref({})
    const options = ref<Required<DialogOptions>>({ ...DEFAULT_OPTIONS })

    const onChangeDialog = (v: boolean) => { isOpen.value = v }

    const openDialog = (content2: Component, bindProperties2: any, options2?: DialogOptions) => {
        isOpen.value = true
        content.value = content2
        bindProperties.value = bindProperties2
        // Always reset to defaults first so a previous dialog's options never leak.
        options.value = { ...DEFAULT_OPTIONS, ...(options2 ?? {}) }
    }

    const closeDialog = () => { isOpen.value = false }

    return { isOpen: toRef(isOpen), content, bindProperties, options, onChangeDialog, openDialog, closeDialog }
})
